/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BannerDto } from '../../models/banner-dto';

export interface BannerClientControllerFindByIdV1$Params {
  id: string;
}

export function bannerClientControllerFindByIdV1(http: HttpClient, rootUrl: string, params: BannerClientControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
  const rb = new RequestBuilder(rootUrl, bannerClientControllerFindByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BannerDto>;
    })
  );
}

bannerClientControllerFindByIdV1.PATH = '/api/v1/banners/client/{id}';
